"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created on Tue Aug 14 2018
 */

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Statistics about children categories for settings of a product category.
 *
 * @author Radek Beran
 */


var SettingsChildrenStats =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SettingsChildrenStats, _DomainObject_1$Domai);

  /**
   * @param includedChildrenCount count of included children categories
   * @param childrenCount count of all children categories
   */
  function SettingsChildrenStats(includedChildrenCount, childrenCount) {
    var _this;

    _classCallCheck(this, SettingsChildrenStats);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SettingsChildrenStats).call(this));
    _this.includedChildrenCount = includedChildrenCount;
    _this.childrenCount = childrenCount;
    return _this;
  }
  /**
   * Converter from data-dictionary representation to price zone release prices.
   */


  _createClass(SettingsChildrenStats, [{
    key: "yesAll",
    value: function yesAll() {
      return this.childrenCount > 0 && this.includedChildrenCount === this.childrenCount;
    }
  }, {
    key: "notAll",
    value: function notAll() {
      return this.childrenCount > 0 && this.includedChildrenCount > 0 && this.includedChildrenCount < this.childrenCount;
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new SettingsChildrenStats(mat.includedChildrenCount, mat.childrenCount);
    }
  }]);

  return SettingsChildrenStats;
}(DomainObject_1.DomainObject);

exports.SettingsChildrenStats = SettingsChildrenStats; // tslint:disable-next-line:member-ordering

SettingsChildrenStats.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SettingsChildrenStats.name);
  return {
    includedChildrenCount: builder.num('includedChildrenCount'),
    childrenCount: builder.num('childrenCount')
  };
}();